/**
 * Resolves an interface type name to its concrete implementing class name,
 * using the project's `Ixxx` -> `xxx` naming convention. Falls back to an
 * explicit override map for cases where the DI bootstrapper binds a
 * different concrete type than the name would suggest.
 * @param {string} typeName - dependency type as parsed (may not start with 'I')
 * @param {Record<string,string>} [overrides] - interfaceName -> concreteClassName, for bootstrapper exceptions
 * @returns {string} concrete class name (best-effort; non-`Ixxx` names pass through unchanged)
 */
export function resolveConcreteClassName(typeName, overrides = {}) {
  if (overrides[typeName]) {
    return overrides[typeName];
  }
  if (/^I[A-Z]/.test(typeName)) {
    return typeName.slice(1);
  }
  return typeName;
}
